import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/Singing/editor/singingeditor.tsx",
    () => import("./singingeditor"),
);
